import React from "react";
import { FiDownload, FiFileText, FiCalendar } from "react-icons/fi";

const FORMAT_COLOR = { PDF: "#ef4444", Excel: "#10b981", "PDF + Excel": "#6366f1" };

const WmReportsPanel = ({ d }) => (
  <div className="wm-reports">

    <div className="wr-header">
      <div className="wr-header-title">Reports & Compliance</div>
      <div className="wr-header-sub">Download detailed water management reports for audits and billing</div>
    </div>

    <div className="wr-reports-grid">
      {d.reports.map(r => (
        <div key={r.id} className="wr-report-card">
          <div className="wr-report-icon">
            <FiFileText size={24} color="#3b82f6" />
          </div>
          <div className="wr-report-info">
            <div className="wr-report-name">{r.name}</div>
            <div className="wr-report-desc">{r.description}</div>
            <div className="wr-report-meta">
              <span className="wr-report-period"><FiCalendar size={11} /> {r.period}</span>
              <span className="wr-report-size">{r.size}</span>
              <span className="wr-report-format" style={{ color: FORMAT_COLOR[r.format] || "#667eea" }}>
                {r.format}
              </span>
            </div>
          </div>
          <button className="wr-download-btn">
            <FiDownload size={14} /> Download
          </button>
        </div>
      ))}
    </div>

    <div className="wr-compliance-note">
      <FiFileText size={16} color="#3b82f6" />
      <span>
        Compliance reports are generated as per <strong>CGWA (Central Ground Water Authority)</strong> and
        Maharashtra State Water Board guidelines. Ensure quarterly submission.
      </span>
    </div>
  </div>
);

export default WmReportsPanel;
